import { render, staticRenderFns } from "./rightsFooter.vue?vue&type=template&id=5a2884de&scoped=true&"
import script from "./rightsFooter.vue?vue&type=script&lang=js&"
export * from "./rightsFooter.vue?vue&type=script&lang=js&"
import style0 from "./rightsFooter.vue?vue&type=style&index=0&id=5a2884de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2884de",
  null
  
)

export default component.exports